import React, { useContext, useState, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { FormGroup, FormControlLabel, Checkbox, Box } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from 'Api';
import CheckoutElementsStripe from './CheckoutElementsStripe';
import PageLayout from '../page-layout';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const StripeElements = () => {
  const { stripeUiSelector, setisFromAffl, isFromAffl, setAppSnackbar, screatId } = useContext(AppContext);
  console.log('stripeUiSelector', stripeUiSelector, screatId);
  const options = {
    clientSecret: screatId,
    appearance: {
      theme: 'flat',
      variables: {
        colorPrimary: '#1a1c22',
        colorText: '#15171c',
        fontFamily: 'Montserrat, system-ui, sans-serif',
        borderRadius: '8px',
      },
    },
  };
  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutElementsStripe />
    </Elements>
  );
};

export default StripeElements;
